var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path7, _path8, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path9, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path10, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path11, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _path12, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path13, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _path14, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _path15, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1062.23004,
    height: 595,
    viewBox: "0 0 1062.23004 595",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M702.77148,153.76558q-.83989-.51-1.67993-.99H642.65161c-.42.66-.82007,1.33-1.21,2h63.01C703.8916,154.43556,703.33154,154.10555,702.77148,153.76558Zm-386.5,197.47v14.9c.25.02.51.02.76.03l-.5,28.64-.26-.13995v2.81994l.21009.11005-.21009,12.01v41.4h2v-106.52Q317.43159,347.72561,316.27148,351.23555Zm386.5-197.47q-.83989-.51-1.67993-.99H642.65161c-.42.66-.82007,1.33-1.21,2h63.01C703.8916,154.43556,703.33154,154.10555,702.77148,153.76558Zm176.5-.99h-556a7.00779,7.00779,0,0,0-7,7v581a7.01519,7.01519,0,0,0,7,7h556a7.00762,7.00762,0,0,0,7-7v-581A7.00763,7.00763,0,0,0,879.27148,152.77559Zm5,588a5.00181,5.00181,0,0,1-5,5h-556a5.00189,5.00189,0,0,1-5-5v-581a5.00832,5.00832,0,0,1,5-5h556a5.00824,5.00824,0,0,1,5,5Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.54035,586.78942c-25.90558-.62006-53.67749,13.89532-61.04907,38.73767l140.62439-5.72473q-3.98924-2.75748-8.01441-5.446C446.525,600.00554,422.44587,587.40953,396.54035,586.78942Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M476.11567,619.80236c18.70032,12.92633,36.95013,26.72174,57.78656,35.69531,51.59418,22.21991,110.98785,11.85718,165.27521-2.58484,54.28735-14.442,109.70312-32.79193,165.38324-25.34839,31.57342,4.22089,61.38159,16.57367,91.85791,25.84131s63.26745,15.47345,94.0158,7.15277c30.74842-8.32068,58.483-34.70563,59.28693-66.5498C877.58887,551.08928,662.37614,549.81493,476.11567,619.80236Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.54035,632.78942c-25.90558-.62006-53.67749,13.89532-61.04907,38.73767l140.62439-5.72473q-3.98924-2.75748-8.01441-5.446C158.525,646.00554,134.44587,633.40953,108.54035,632.78942Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.11567,665.80236c18.70032,12.92633,36.95013,26.72174,57.78656,35.69531,51.59418,22.21991,110.98785,11.85718,165.27521-2.58484,54.28735-14.442,109.70312-32.79193,165.38324-25.34839,31.57342,4.22089,61.38159,16.57367,91.85791,25.84131s63.26745,15.47345,94.0158,7.15277c30.74842-8.32068,58.483-34.70563,59.28693-66.5498C589.58887,597.08928,374.37614,595.81493,188.11567,665.80236Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M499.82792,451.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,499.82792,451.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 309.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 326.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 343.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 360.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 377.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 394.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 411.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 428.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 445.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M649.87736,327.77105l-17.84607-38.39618a16.302,16.302,0,0,0-14.78314-9.43085h-21.028a18,18,0,1,0-31.14453,0H544.04771a16.302,16.302,0,0,0-14.78314,9.43085L511.4185,327.77105a16.30193,16.30193,0,0,0,14.78314,23.173h49.44629v186h10v-186h49.44629A16.30193,16.30193,0,0,0,649.87736,327.77105Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M856.82792,451.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,856.82792,451.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 666.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 683.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 700.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 717.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 734.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 751.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 768.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 785.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 802.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M694.82792,451.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,694.82792,451.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 504.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 521.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 538.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 555.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 572.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 589.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 606.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 623.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 640.65665,
    y: 298.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M867.82792,382.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,867.82792,382.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 677.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 694.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 711.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 728.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 745.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 762.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 779.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 796.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 813.65665,
    y: 229.86845,
    width: 4,
    height: 68.59998,
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M824.82792,456.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,824.82792,456.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 634.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 651.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 668.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 685.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 702.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 719.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 736.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 753.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 770.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M641.82792,456.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,641.82792,456.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 451.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 468.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 485.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 502.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 519.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 536.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 553.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 570.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 587.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M696.82792,387.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,696.82792,387.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 506.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 523.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 540.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 557.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 574.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 591.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 608.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 625.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 642.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M446.82792,456.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,446.82792,456.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 256.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 273.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 290.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 307.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 324.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 341.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 358.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 375.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 392.65665,
    y: 303.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M482.82792,387.644h-145.36a7.825,7.825,0,0,0-7.82,7.81994v52.96a7.825,7.825,0,0,0,7.82,7.82h145.36a7.825,7.825,0,0,0,7.82-7.82v-52.96A7.825,7.825,0,0,0,482.82792,387.644Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 292.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 309.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 326.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 343.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 360.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 377.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 394.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 411.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 428.65665,
    y: 234.86845,
    width: 4,
    height: 68.59998,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M952.80442,529.29406a16.67245,16.67245,0,0,0-.92706-2.523l-17.84607-38.39618a16.302,16.302,0,0,0-14.78314-9.43085H846.04771a16.302,16.302,0,0,0-14.78314,9.43085l-14.673,31.56915H398.23948l-14.20819-30.56915a16.302,16.302,0,0,0-14.78314-9.43085H296.04771a16.27567,16.27567,0,0,0-8.01544,2.11487l-12.30756-21.97784a7.51762,7.51762,0,0,0-14.07678,3.67315V636.36132a19.58267,19.58267,0,0,0,19.5827,19.5827H841.4083a19.58274,19.58274,0,0,0,14.00061-5.89093l94.69855-96.83465A19.40952,19.40952,0,0,0,952.80442,529.29406Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M854.24656,517.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V499.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,854.24656,517.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M887.24656,517.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V499.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,887.24656,517.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M920.24656,517.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V499.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,920.24656,517.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M552.24656,318.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V300.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,552.24656,318.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M585.24656,318.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V300.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,585.24656,318.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M618.24656,318.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V300.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,618.24656,318.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M304.24656,518.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V500.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,304.24656,518.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M337.24656,518.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V500.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,337.24656,518.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M370.24656,518.444h-9.19727a7.40984,7.40984,0,0,1-7.40136-7.40136V500.84539a7.40985,7.40985,0,0,1,7.40136-7.40137h9.19727a7.40985,7.40985,0,0,1,7.40137,7.40137v10.19727A7.40985,7.40985,0,0,1,370.24656,518.444Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M247.17094,623.75884c-25.90558-.62-53.67749,13.89533-61.04907,38.73767l140.62438-5.72473q-3.98922-2.75748-8.0144-5.446C297.15562,636.975,273.07645,624.379,247.17094,623.75884Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M326.74625,656.77178c18.70032,12.92633,36.95014,26.72174,57.78656,35.69531C436.127,714.687,495.52067,704.32427,549.808,689.88226s109.70313-32.79194,165.38324-25.34839c31.57343,4.22088,61.38159,16.57367,91.85791,25.84131s63.26746,15.47345,94.01581,7.15277c30.74841-8.32068,58.483-34.70563,59.28693-66.54981C728.21946,588.05871,513.00672,586.78436,326.74625,656.77178Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#479e35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 767.07627,
    cy: 60.12699,
    r: 26.70075,
    fill: "#fd6584"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M874.32572,200.25933a13.23512,13.23512,0,0,0-11.17-9.29,1.08068,1.08068,0,0,0-.18,0,1.418,1.418,0,0,0-.22-.05c-8.94-1.16-18.88,1.66-25.57,7.8l-.07337.06734a13.543,13.543,0,0,1-12.82582,3.10644,11.89088,11.89088,0,0,0-3.76078-.41383,13.18351,13.18351,0,0,0-11.8,9.51,1.52647,1.52647,0,0,0,.69,1.69,6.673,6.673,0,0,0,2.79,1.42c2.21.47,4.44.9,6.67,1.29q6.54,1.14,13.15,1.85,4.365.465,8.75.74c6.04.38,12.11.47,18.16.28,3-.1,5.88-.2,8.62-1.52a12.79756,12.79756,0,0,0,4.95-4.31A14.54776,14.54776,0,0,0,874.32572,200.25933Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M819.39572,239.15935a13.65229,13.65229,0,0,0-.56-3.3,13.26028,13.26028,0,0,0-11.18-9.29.9647.9647,0,0,0-.17,0,1.88685,1.88685,0,0,0-.23-.05,33.19372,33.19372,0,0,0-14.69,1.51,30.31757,30.31757,0,0,0-10.947,6.351,13.53612,13.53612,0,0,1-12.82651,3.11253,11.92644,11.92644,0,0,0-3.76652-.41357,13.18343,13.18343,0,0,0-11.8,9.51,1.5553,1.5553,0,0,0,.69,1.69,6.733,6.733,0,0,0,2.79,1.42c2.22.47,4.44.9,6.68,1.29q6.54,1.14,13.14,1.85a195.16559,195.16559,0,0,0,26.92,1.02c2.99-.1,5.88-.2,8.62-1.52a12.7697,12.7697,0,0,0,4.94-4.31A14.26445,14.26445,0,0,0,819.39572,239.15935Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M829.30809,304.405a5.60972,5.60972,0,0,0,.62525,4.0841,3.40813,3.40813,0,0,0,3.96161,1.31053c2.797-.86838,5.55644-1.8854,8.32953-2.82773a1.53546,1.53546,0,0,0,1.04766-1.84518,1.51454,1.51454,0,0,0-1.84518-1.04766l-6.9298,2.35485c-.52273.17763-1.04358.37962-1.57624.52547-.05569.01525-.2592.06-.24824.059.02556-.00237.18358.0145.0082.00235q-.15-.04512.00207.01968l-.13254-.07544c.121.10071-.01458-.01348-.05627-.05577-.03674-.03728-.14476-.18594-.06133-.06376a1.85479,1.85479,0,0,1-.15708-.2756c.07319.16206-.06425-.23882-.07395-.29431a6.42383,6.42383,0,0,1,.10631-1.87054,1.50734,1.50734,0,0,0-1.5-1.5,1.53858,1.53858,0,0,0-1.5,1.5Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M717.62654,309.67211l7.39319,9.32218c.94082,1.1863,2.95772-.09794,2.50707-1.45942-.92158-2.78427,2.25946-4.33569,4.45518-4.79414,2.91329-.60828,5.83651-.50961,8.60082-1.76169,1.756-.79538.23267-3.38163-1.51416-2.59041-3.23363,1.46465-7.00412.79322-10.27849,2.2179-2.92668,1.27341-5.24081,4.449-4.15618,7.72586L727.141,316.873l-7.39319-9.32219a1.51045,1.51045,0,0,0-2.12132,0,1.5349,1.5349,0,0,0,0,2.12133Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M702.62654,200.67211l7.39319,9.32218c.94082,1.1863,2.95772-.09794,2.50707-1.45942-.92158-2.78427,2.25946-4.33569,4.45518-4.79414,2.91329-.60828,5.83651-.50961,8.60082-1.76169,1.756-.79538.23267-3.38163-1.51416-2.59041-3.23363,1.46465-7.00412.79322-10.27849,2.2179-2.92668,1.27341-5.24081,4.449-4.15618,7.72586L712.141,207.873l-7.39319-9.32219a1.51045,1.51045,0,0,0-2.12132,0,1.5349,1.5349,0,0,0,0,2.12133Z",
    transform: "translate(-47.49128 -152.77559)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.52f2e90b01381a9cdc65b75a30a9d827.svg";
export { ForwardRef as ReactComponent };